import { actionTypes } from "../actions/default.action"

const initialState = {
  affiliateDomains: {
    data: [],
  },
  affiliateDomain: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        affiliateDomains: {
          ...state.affiliateDomains,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        affiliateDomains: {
          ...state.affiliateDomains,
          data: state.affiliateDomains.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        affiliateDomain: {
          ...state.group,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
